import { ENV } from "@vrf/fr-vrf-core";
import { InDefCommonFlagType } from "../../util/general-code/enums/general-codes";

export const TEMPLATE_FILE_URL =
  "spreadsheet-template/component-addition-page-pic-address.xlsx";

export enum ComponentAdditionPageMode {
  ADD_ROOT_COMPONENT = "addRootComponent",
  ADD_COMPONENT = "addComponent",
}
export const REQUEST_CD_TYPES = {
  CPNT_OWN_TYPE: "cpnt_own_type",
  CPNT_ALCTN_TYPE: "cpnt_alctn_type",
  CLOD_SRVC_RGN: "clod_srvc_rgn",
  CLOD_SRVC: "clod_srvc",
  INTERFACE_START_METHOD_TYPE: "interface_start_method_type",
};

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);

export const isChecked = (value: string) => value === InDefCommonFlagType.YES;
